import React, {useRef, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import {Select} from '../../../../../../../components';
import {Field} from 'react-final-form';
import {connect} from 'react-redux';

function DealSelect(props){
  let deals=[]; if(props.deals!=undefined && props.deals[props.company.id]!=undefined){for(let key in props.deals[props.company.id]){let d=props.deals[props.company.id][key]; deals.push({value:d.id, name:d.name});}}
  useEffect(()=>{
    if(props.deals==undefined || props.deals[props.company.id]==undefined){props.indexDeals(props.company.id);}
  },[]);
  if(deals.length==0){return(null);}
  deals.unshift({value:'', name:(props.workspace!=undefined && props.workspace.deal_filter_restrictive==true)?'Unassigned':'Visible on all deals'});
  console.log(deals, 'DEALS');
  return(<Grid item xs={12} style={{marginBottom:'15px'}}>

    <Select title='Deal' name='deal_id'  select_data={deals}/></Grid>)
}


export default connect(ss, dd)(DealSelect)

function ss(state){
  return{
    deals:state.deals.deals,
    }
}

//The sales coach refresh thing is for deals

function dd(dispatch){
   return{
     indexDeals:(company_id)=>{dispatch({type:'REQUEST_INDEX_DEALS', company_id:company_id})},
   }
}
